export class CarRentalItemsFilterFormModel {
  constructor(transmission, priceRange, seats) {
    this.transmission = transmission;
    this.priceRange = priceRange;
    this.seats = seats;
  }
}
